import { render } from "./ScrollToTopButton.vue?vue&type=template&id=6d887f6a&scoped=true"
import script from "./ScrollToTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollToTopButton.vue?vue&type=script&lang=js"

import "./ScrollToTopButton.vue?vue&type=style&index=0&id=6d887f6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d887f6a"]])

export default __exports__